/**
* @file 资源管理-安全检查
* */
<template>
  <div id="securityInspector">
    <custom-table ref="customTable" :customOptions="customOptions" :columns="columns" excel-type="InspectRecord"
                  :export-required-fields="[{ prop: 'startTime', text: '请选择检查时间起-检查时间止' }, { prop: 'endTime', text: '请选择检查时间起-检查时间止' }]">
      <template slot-scope="{ item, row }">
        <template v-if="item.prop === 'created'">{{ row.created | filterTime('YYYY/MM/DD HH:mm:SS') }}</template>
        <template v-else-if="item.prop === 'licenseNo'">
          <span v-if="row.licenseNo" :style="getPlateStyle(row.licenseNo)">{{ formatPlateNumber(row.licenseNo) }}</span>
          <span v-else>-</span>
        </template>
        <template v-else-if="item.prop === 'result'">
          <span :style="{ color: row.result == 1 ? '#009900' : '#FF0000' }">
            {{ row.result == 1 ? '通过' : '不通过' }}
          </span>
        </template>

        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
      <template slot="table-operation">
        <el-table-column label="操作" width="150" fixed="right" v-slot="{ row }">
          <el-button type="text" @click="look(row)">查看</el-button>
          <el-button type="text" @click="print(row)">打印例检合格证</el-button>
        </el-table-column>
      </template>
    </custom-table>

    <!-- 合格证打印内容 -->
    <div id="print" v-if="printContent.organizationName">
      <div style="display: inline-block;padding: 2rem 5px;font-size:9px">
        <div style="margin-bottom: 5px;text-align: center;">{{ printContent.organizationName }}</div>
        <div style="margin-bottom: 20px;text-align: center;">营运客车例检合格证</div>

        <div style="margin-bottom: 20px;padding: 8px 10px;border: 1px black solid;line-height: 2rem;">
          <div>编号：{{ printContent.number }}</div>
          <div>检查时间：{{ printContent.created | filterTime('YYYY.MM.DD HH:mm') }}</div>
          <div>车辆号牌：{{ printContent.licenseNo }}</div>
          <div>安全检查员：{{ printContent.inspectorName }}</div>
          <div>
            检查结果：
            <span
                :style="{ fontSize: printContent.result == 1 ? '' : '17px', fontWeight: printContent.result == 1 ? '' : 'bold' }">
              {{ printContent.result == 1 ? '通过' : '不通过' }}
            </span>
          </div>
          <div>安全例检合格证：（盖章）</div>
        </div>

        <div>注：本通知单随车携带，24小时内报班有效！</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "securityInspector",
  data() {
    return {
      // 配置项
      customOptions: {
        showLabel: false,
        // 请求的列表url
        url: "/api/v1/manage/inspect/list",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          {type: "input", field: "licenseNo", name: "车辆号牌", value: ""},
          {type: "input", field: "vehicleNo", name: "车辆编号", value: ""},
          {type: "input", field: "vehicleModel", name: "车辆型号", value: ""},
          {type: "input", field: "inspectorName", name: "安检员", value: ""},
          {type: "input", field: "inspectorOrganizationName", name: "安检机构", value: ""},
          {
            type: "select", field: "result", name: "安检结果", value: "",
            option: [{label: '通过', value: 1}, {label: '不通过', value: '0'}]
          },
          {type: "datetime", field: "time", name: "检查日期", value: []},
          {type: "input", field: "number", name: "检查编号", value: ""},
        ],
      },
      columns: [
        {prop: "organizationName", label: "机构名称"},
        {prop: "licenseNo", label: "车辆号牌", width: 120},
        {prop: "vehicleNo", label: "车辆编号", width: 120},
        {prop: "vehicleModel", label: "车型", width: 120},
        {prop: "vehicleSeat", label: "座位数", width: 100},
        {prop: "inspectorName", label: "安检员", width: 120},
        {prop: "inspectorOrganizationName", label: "安检机构"},
        {prop: "result", label: "安检结果", width: 100},
        {prop: "number", label: "检查编号", width: 100},
        {prop: "created", label: "检查日期", width: 150},
      ],

      printContent: {}
    };
  },
  methods: {
    look(row) {
      this.$router.push({path: '/securityInspectorDetail', query: {id: row.id}})
    },

    /* 打印合格证 */
    print(row) {
      this.printContent = {
        organizationName: row.organizationName,
        number: row.number,
        created: row.created,
        licenseNo: row.licenseNo,
        inspectorName: row.inspectorName,
        result: row.result
      }

      this.$nextTick(() => {
        const printContentHtml = document.getElementById("print").innerHTML;
        const iframe = document.createElement("iframe");
        document.body.appendChild(iframe);
        iframe.contentDocument.write(printContentHtml);
        iframe.contentDocument.close();
        iframe.contentWindow.print();
      })
    },
  }
};
</script>

<style lang="less">
iframe,
#print {
  width: 0;
  height: 0;
  position: absolute;
  left: -500px;
  top: -500px;
}
</style>
